/**
 * Who owns the browser session
 */
export const AuthMode = {
  /**
   * API runs the OIDC flow (`/auth/oauth/rc/*`) and owns the cookie session and CSRF token
   */
  ApiSession: 'api-session',

  /**
   * session-manager owns the session (Keycloak); the portal host proxies `/auth/*` and `/api/*` to it
   */
  SessionManager: 'session-manager',
} as const;
